/**
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *  This file is part of Neo4j.
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TypographyDefault } from './typography-default.story';
export { default as TypographyAnchor } from './typography-anchor.story';
export { default as TypographyVariants } from './typography-variants.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TypographyAnchorSourceRaw from './typography-anchor.story?raw';
import TypographyDefaultSourceRaw from './typography-default.story?raw';
import TypographyVariantsSourceRaw from './typography-variants.story?raw';

export const TypographyDefaultSource = removeLicenseHeader(
  TypographyDefaultSourceRaw,
);
export const TypographyAnchorSource = removeLicenseHeader(
  TypographyAnchorSourceRaw,
);
export const TypographyVariantsSource = removeLicenseHeader(
  TypographyVariantsSourceRaw,
);
